import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

export const getCountryById = createAsyncThunk(
  "countriesId/getCountryById",
  async (payload) => {
    const response = await axios
      .get(`https://sleepy-fjord-53264.herokuapp.com/countries/${payload}`)
      .catch((error) => {
        return error.data;
      });

    return response.data;
  }
);
const initialState = {
  countryId: [],
};
const countryIdSlice = createSlice({
  name: "countryId",
  initialState,
  reducers: {},
  extraReducers: {
    [getCountryById.pending]: () => {},
    [getCountryById.fulfilled]: (state, action) => {
      return { countryId: action.payload };
    },
  },
});

export default countryIdSlice.reducer;
export const countrybyId = (state) => state.countryId.countryId;
